<template>
  <div>
    <BaseButton type="button" ghost small class="flex items-center" @click="deleteFunnel">
      <span>Delete</span>
    </BaseButton>
  </div>
</template>

<script>
export default {
  props: {
    funnel: {
      type: Object,
      required: true,
    },
    onDeleted: {
      type: Function,
      default: () => {
        //
      },
    },
  },
  data() {
    return {
      show: false,
    };
  },
  methods: {
    deleteFunnel() {
      this.$modal.show({
        component: () => import('Components/Funnel/FunnelDeleteModal.vue'),
        props: {
          funnelId: this.funnel.id,
        },
        on: {
          destroyed: this.onDeleted,
        },
        hideEvent: 'close',
      });
    },
  },
};
</script>
